import type { SxProps, Theme } from '@mui/material/styles';

type AccountsListStyleMap = {
    root: SxProps<Theme>
    header: SxProps<Theme>
    filtersPaper: SxProps<Theme>
    searchField: SxProps<Theme>
    roleToggle: SxProps<Theme>
    tableContainer: SxProps<Theme>
    tableHeaderRow: SxProps<Theme>
    tableHeaderCell: SxProps<Theme>
    loadingCell: SxProps<Theme>
    userCell: SxProps<Theme>
    userAvatar: SxProps<Theme>
    emptyCell: SxProps<Theme>
};

export const accountsListStyles: AccountsListStyleMap = {
    root: { display: 'flex', flexDirection: 'column', gap: 3 },
    header: { display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { sm: 'flex-start' }, gap: 2 },
    filtersPaper: { border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 2, display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center', justifyContent: 'space-between' },
    searchField: { maxWidth: 300 },
    roleToggle: { textTransform: 'none' },
    tableContainer: { border: '1px solid', borderColor: 'divider', borderRadius: 2 },
    tableHeaderRow: { bgcolor: 'grey.50' },
    tableHeaderCell: { fontWeight: 600 },
    loadingCell: { py: 5 },
    userCell: { display: 'flex', alignItems: 'center', gap: 1.5 },
    userAvatar: { width: 36, height: 36, fontSize: 14, fontWeight: 700, bgcolor: 'primary.light' },
    emptyCell: { py: 5, color: 'text.secondary' },
};
